<template>
  <a class="pointer edit" @click="click" v-c-tooltip.hover.click="'Edit'">
    <CIcon name="cil-pen" />
  </a>
</template>
<script>
export default {
  prop: [],
  methods: {
      click() {
          this.$emit('click')
      }
  }
};
</script>